import React, { useEffect, useState } from 'react';
import Theme from '../Theme/Theme';
import Toggle from '../ToggleSection/Toggle';
import './Controls.css';



export default function App() {
  return (
    <>
    <Toggle/>
      <Theme />
    </>
  );
}

